controllers.controller('AccountsChangePasswordController', [
    '$scope', '$state', '$ionicLoading', '$ionicHistory', 'LocaleService', 'UserService', 'constants', 'API', 'ErrorService', 'Utils','Validator',
    function ($scope, $state, $ionicLoading, $ionicHistory, LocaleService, UserService, Const, API, ErrorService, Utils, Validator) {
        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });
        $scope.user = UserService.get();
        $scope.validator = Validator.getPattern;

        $scope.tradingAccounts = $scope.user.tradingAccounts;
        $scope.initialSelectedAccount = null;

        $scope.auth = {
            password: "",
            confirmPassword: "",
            tradingAccount: $scope.user.activeTradingAccount
        };

        var modalDefaults = {
            isError: false,
            textTitle: "",
            textContent: "",
            state: false,
            isProcess: false
        };

        $scope.modal = angular.copy(modalDefaults);

        function checkResponse(response, request) {
            if (response.status === 0) {
                throw new ErrorService({
                    source: 'AccountsChangePasswordController',
                    type: Const.error.type.VALIDATION,
                    severity: 'warning',
                    code: response.code || 'general_error',
                    data: {
                        request: request,
                        response: response
                    }
                })
            }
            return response;
        }

        $scope.changeAccountPassword = function (form) {
            Utils.formRevalidate(form);
            if (!form.$valid) return;
            $ionicLoading.show();
            var req = {
                login: $scope.auth.tradingAccount.login,
                source: $scope.auth.tradingAccount.source,
                password: $scope.auth.password
            };
            API.mt4AccountSetPassword(req).then(function (res) {
                return checkResponse(res, req);
            }).then(function (res) {
                $ionicLoading.hide();
                $scope.modal.isError = false;
                $scope.modal.isProcess = false;
                $scope.modal.textTitle = LocaleService.translation.messages.password_changed;
                $scope.modal.back = "root.app.manageAccounts";
                $scope.modal.actionText = LocaleService.translation.back;
                $scope.modal.state = true;
            }).catch(function (error) {
                $ionicLoading.hide();
                $scope.modal.isError = true;
                $scope.modal.isProcess = false;
                $scope.modal.textTitle = error && LocaleService.translation.messages[error.code] || LocaleService.translation.messages.general_error;
                $scope.modal.textContent = LocaleService.translation.messages.err_password_changed;
                $scope.modal.actionText = LocaleService.translation.try_again;
                $scope.modal.state = true;
            });
        };
    }]);
